import Grid from '@mui/material/Grid2';
import Input from '@mui/material/Input';
import { styled } from '@mui/material/styles';
import Icon from 'Components/Icon';
import React from 'react';
import icons from 'utils/ui/icons';

// Styled Grid item for the search icon
const GridIconWrapper = styled(Grid)(({ theme }) => ({
    display: 'grid',
    placeItems: 'center',
    padding: theme.spacing(0, 1) // Add some padding around the icon
}));

// Styled Grid container to center the entire search bar
const CenteringGridContainer = styled(Grid)(() => ({
    display: 'flex',         // Use flexbox for centering
    justifyContent: 'center', // Center horizontally
    alignItems: 'center',     // Align items vertically (optional, but good practice)
    width: '100%'            // Take up the full width of its parent
}));

const SearchInput = ({ loading, onSearchChange, searching, searchValue }) => {
    return (
        <CenteringGridContainer container>
            <GridIconWrapper>
                <Icon icon={(loading || searching) ? icons.spinner : icons.search} spin={loading || searching}/>
            </GridIconWrapper>
            <Grid size={3}>
                <Input
                    disabled={loading}
                    fullWidth
                    onChange={event => {
                        onSearchChange(event.target.value);
                    }}
                    placeholder={loading ? 'Loading data…' : 'Search…'}
                    size="small"
                    value={searchValue}
                    variant="outlined"
                />
            </Grid>
        </CenteringGridContainer>
    );
};

export default SearchInput;
